import { rem } from 'polished'
import styled from 'styled-components'

const ProgressIndicatorContainer = styled.div`
  min-height: ${rem(3)};
  background-color: ${(props) => props.theme.palette.neutral.surface.lightBackground};
  position: relative;
`

const ProgressIndicator = styled.div`
  background-color: ${(props) =>
    props.theme.palette.highlight.primary.normalBackground};
  position: absolute;
  top: 0;
  inset-inline-start: 0;
  bottom: 0;
  width: 100%;
  transform-origin: 0% 50%;
  transition: transform 0.2s ease-out;

  [dir="rtl"] & {
    transform-origin: 100% 50%;
  }
`

interface Props {
  percentage: number
}

function ProgressBar({ percentage }: Props) {
  return (
    <ProgressIndicatorContainer>
      <ProgressIndicator style={{ transform: `scaleX(${percentage / 100})` }} />
    </ProgressIndicatorContainer>
  )
}

export default ProgressBar
